import { createSelector } from "@reduxjs/toolkit";
import { mapKeys, reduce } from "lodash-es";

import { IEventSuggestedLocation, ITravelBlockPassenger } from "Bands/types";
import { IDataKeys } from "shared/types";
import { dataSelector, buildData } from "../helpers";
import { API_ENDPOINTS } from "shared/constants";

export const suggestedLocationsSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.eventSuggestedLocation) as IEventSuggestedLocation[]
);

export const googleLocationsSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.eventGoogleLocation) as IEventSuggestedLocation[]
);

const travelBlockPassengersSelector = createSelector(dataSelector, data => {
  return buildData(data as any, IDataKeys.eventTravelBlockPassenger) as ITravelBlockPassenger[];
});

export const travelBlockPassengersSelectorCreator = (passengerPaths?: string[]) =>
  createSelector(travelBlockPassengersSelector, passengers => {
    return mapIdsToPassengers(passengerPaths, passengers);
  });

const mapIdsToPassengers = (passengerPaths: string[] = [], passengers: ITravelBlockPassenger[]) => {
  const passengersMap = mapKeys(passengers, ({ id }) =>
    API_ENDPOINTS.EVENT_TRAVEL_BLOCK_PASSENGER(id)
  );

  return reduce(
    passengerPaths,
    (selectedPassengers: ITravelBlockPassenger[], path) => {
      const selectedPassenger = passengersMap?.[path];

      if (selectedPassenger) {
        return [...selectedPassengers, selectedPassenger];
      }

      return selectedPassengers;
    },
    []
  );
};
